import dayjs from 'dayjs';
import jwt from 'jsonwebtoken';

import { StorageService } from './storage.service';

export const AuthenticationService = {
  isLoggedIn: () => {
    try {
      const authTokens = StorageService.getAuthKey();
      if (!authTokens) return false;
      const { expiry } = authTokens;
      if (dayjs().isAfter(expiry)) {
        AuthenticationService.logout();
        return false;
      }
      return true;
    } catch (e) {
      return undefined;
    }
  },
  logout: () => StorageService.setAuthKey(undefined),
  getAuthToken: () => {
    if (AuthenticationService.isLoggedIn()) {
      const { value } = StorageService.getAuthKey();
      return value.token;
    }
    return undefined;
  },
  getCurrentUser: () => {
    if (AuthenticationService.isLoggedIn()) {
      const { value } = StorageService.getAuthKey();
      try {
        return jwt.decode(value.token);
      } catch (e) {
        return undefined;
      }
    }
    return undefined;
  },
};
